import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import { siteContext } from "../../config/apiEndpoints";
import { STORE_OFFLINE_NOTIFICATION_DATA } from "../../helpers/notificationConstants";

export default {
  namespaced: true,
  state: {
    notificationData: [],
    notificationVisibilityStatus: false,
    notificationStatusData: [],
    showNotificationStatusData: false,
    notificationPosition: "",
  },
  getters: {},
  mutations: {
    updateNotificationData(state, payload) {
      state.notificationData = payload;
    },
    updateNotificationStatusData(state, payload) {
      let currentNotificationStatusData = state.notificationStatusData;
      let found = false;
      for (let i = 0; i < currentNotificationStatusData.length; i++) {
        if (currentNotificationStatusData[i]?.id == payload?.id) {
          found = true;
          break;
        }
      }
      if (!found) {
        currentNotificationStatusData.push(payload);
      }
      state.notificationStatusData = currentNotificationStatusData;
    },
    updateShowNotificationStatusData(state, payload) {
      state.showNotificationStatusData = payload;
    },
    updateNotificationVisibilityStatusData(state, payload) {
      state.notificationVisibilityStatus = payload;
    },
    updateNotificationPosition(state, payload) {
      state.notificationPosition = payload;
    },
    removeNotificationStatusData(state, payload) {
      let currentNotificationStatusData = state.notificationStatusData;
      let filteredNotification = [];
      currentNotificationStatusData.map((notification) => {
        if (notification.id != payload.id) {
          filteredNotification.push(notification);
        }
      });
      state.notificationStatusData = filteredNotification;
    },
    updateNotificationDataInCaseOfFailure(state, payload) {
      let tempNotificationData = [];
      let lastLocation =
        LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp();
      if (lastLocation.length && lastLocation[0]?.recent) {
        if (lastLocation[0]?.recent?.online == 0) {
          tempNotificationData.push(STORE_OFFLINE_NOTIFICATION_DATA);
        }
      }
      state.notificationData = tempNotificationData;
    },
  },
  actions: {
    getNotificationData({ commit }, payload) {
      apiCalls
        .INLINE_NOTIFICATION_API({
          headers: Headers({ withMobileNo: true, withAuthorizationKey: true }),
          payload: {
            storeId: LocalStorageFunc.storeId(),
            lang: "en",
            platform: "pwa",
            site: siteContext,
            mobile: LocalStorageFunc.getUserMobileNo(),
          },
        })
        .then(function (response) {
          if (response?.data) {
            commit("updateNotificationData", response?.data);
          } else {
            commit("updateNotificationDataInCaseOfFailure");
          }
        })
        .catch(function (error) {
          console.log("error", error);
          commit("updateNotificationDataInCaseOfFailure");
        });
    },
  },
};
